import { PropertyReports } from "./PropertyReports"

export default PropertyReports
